export default "title = 내 레벨\n"